import DataUtility from 'utility/data';
import { deepCopyObject } from "../../../../common/common_utility";

const MathFactReportingInitialState = {
    studentWiseFactDetailLoading: false,
    studentWiseFactDetail: {},
    studentOperatorWiseCountLoading: false,
    studentOperatorWiseCount: {},
    dateWiseStudentActivityLoading: false,
    dateWiseStudentActivity: [],
    dateWiseProficientFactCountLoading: false,
    dateWiseProficientFactCount: {},
    errors: {
        studentWiseFactDetail: null,
        studentOperatorWiseCount: null,
        dateWiseStudentActivity: null,
        dateWiseProficientFactCount: null
    }
}

class MathFactReportingModel {
    static __instance__ = new MathFactReportingModel();
    studentWiseFactDetailLoading = MathFactReportingInitialState.studentWiseFactDetailLoading;
    studentWiseFactDetail = MathFactReportingInitialState.studentWiseFactDetail;
    studentOperatorWiseCountLoading = MathFactReportingInitialState.studentOperatorWiseCountLoading;
    studentOperatorWiseCount = MathFactReportingInitialState.studentOperatorWiseCount;
    dateWiseStudentActivityLoading = MathFactReportingInitialState.dateWiseStudentActivityLoading;
    dateWiseStudentActivity = MathFactReportingInitialState.dateWiseStudentActivity;
    dateWiseProficientFactCountLoading = MathFactReportingInitialState.dateWiseProficientFactCountLoading;
    dateWiseProficientFactCount = MathFactReportingInitialState.dateWiseProficientFactCount;
    errors = deepCopyObject(MathFactReportingInitialState.errors);

    constructor() {}

    static get singleInstance() {
        if(!this.__instance__) {
            this.__instance__ = new MathFactReportingModel();
        }
        return this.__instance__;
    }

    static setStudentWiseFactDetail(data) { this.singleInstance.studentWiseFactDetail = DataUtility.deepMerge(this.singleInstance.studentWiseFactDetail, data); return this.singleInstance;}
    static studentOperatorWiseCount(data) { this.singleInstance.studentOperatorWiseCount = DataUtility.deepMerge(this.singleInstance.studentOperatorWiseCount, data); return this.singleInstance;}
    static dateWiseStudentActivity(data) { this.singleInstance.dateWiseStudentActivity = data; return this.singleInstance;}
    static dateWiseProficientFactCount(data) { this.singleInstance.dateWiseProficientFactCount = data; return this.singleInstance;}

    static toggleStudentWiseFactDetailLoading(value) { this.singleInstance.studentWiseFactDetailLoading = value; return this.singleInstance;}
    static toggleStudentOperatorWiseCountLoading(value) { this.singleInstance.studentOperatorWiseCountLoading = value; return this.singleInstance;}
    static toggleDateWiseStudentActivityLoading(value) { this.singleInstance.dateWiseStudentActivityLoading = value; return this.singleInstance;}
    static toggleDateWiseProficientFactCountLoading(value) { this.singleInstance.dateWiseProficientFactCountLoading = value; return this.singleInstance;}

    /**
     * Set error state for a specific data type
     * 
     * @param {Object|null} errorData - Error object with message, type and originalError or null to clear error
     * @param {string} errorType - Type of data that has error ("studentWiseFactDetail", "studentOperatorWiseCount", etc.)
     * @returns {MathFactReportingModel} Updated model instance
     */
    static setError(errorData, errorType) {
        if (!this.singleInstance.errors) {
            this.singleInstance.errors = {};
        }
        this.singleInstance.errors[errorType] = errorData;
        return this.singleInstance;
    }

    static initialState() {
        this.__instance__ = null;
        return this.singleInstance;
    }
}

export default MathFactReportingModel;